import { render, staticRenderFns } from "./HouseholdIncomeRatio.vue?vue&type=template&id=39e9a902&scoped=true&"
import script from "./HouseholdIncomeRatio.vue?vue&type=script&lang=js&"
export * from "./HouseholdIncomeRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e9a902",
  null
  
)

export default component.exports